import React, { useEffect, useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import FailureAlert from '../Common/Failure';
import baseURL from '../Common/Config';
import * as htmlToImage from 'html-to-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from '../Common/ThemeProvider';
import moment from 'moment';
import {
    ResponsiveContainer, BarChart, XAxis, YAxis, Tooltip, Bar, Cell
} from 'recharts';
import Select from 'react-select';
import DataTable from '../Common/DataTableList';

const TrackReport = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [CompleteReport, setCompleteReport] = useState([]);
    const [TrackReport, setTrackReport] = useState([]);
    const [PartnerData, setPartnerData] = useState([]);
    const [LogData, setLogData] = useState([]);

    useEffect(() => {
        Axiosfetch(`${baseURL}GetTrackReports`, "GET", null, TrackreportSuccess, Failure);

    }, []);

    const columns = React.useMemo(
        () => [
            {
                name: 'SI #',
                width: "80px",
                selector: (row, index) => (index + 1),
                sortable: true,
            },
            {
                name: 'TripID',
                width: "225px",
                selector: row => row.TripID ? <NavLink target="_blank" title="Click to see Tracking" rel="noopener noreferrer" to={`/TrackingDetails/${row.TripID}`}>{row.TripID}</NavLink> : "-",
                sortable: true,
            },
            {
                name: 'Origin',
                selector: row => {
                    return <div>
                        {row.OriginCity}
                    </div>
                },
                sortable: true,
            },
            {
                name: 'Dest',
                selector: row => {
                    return <div>
                        {row.DestCity}
                    </div>

                },
                sortable: true,
            },
            {
                name: 'Truck #',
                selector: row => row.TruckNumber,
                sortable: true,
            },
            {
                name: 'Created Date',
                width: "250px",
                selector: row => moment(row.createdAt).local().format("DD/MM/YYYY hh:mm:ss A"),
            }
        ], []
    );

    const TrackreportSuccess = (data) => {
        if (data.length > 0) {
            var trackdetailsreport = [];
            var trackIds = [];
            setCompleteReport(data);
            data.map(track => {
                return trackdetailsreport.push({ Name: track.Name.split(' ')[0].substr(0, 10), TrackCount: track.TrackCount })
            });

            data.map(track => {
                return trackIds.push({ value: track._id, label: track.Name })
            });

            setTrackReport(trackdetailsreport);
            setPartnerData(trackIds);
        }
        else {
            Alert.error("Error Fetching Member Track report", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            setTrackReport([]);
        }
    };

    const DownloadImage = () => {
        var node = document.getElementById('chartTrack');

        htmlToImage.toPng(node)
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'MemberTrackingReport_' + moment().local().format("DDMMYYYY") + '.png';
                link.href = dataUrl;
                link.click();
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    };

    const getColor = (count) => {
        if (count < 5) { return "#F16D64"; }
        if (count >= 5 && count < 15) { return "#ffb732"; }
        if (count >= 15 && count < 25) { return "#53C2E2"; }
        if (count >= 25 && count < 50) { return "#66b266"; }
        if (count > 50) { return "#198c19"; }
    };

    const onPartnerChange = (data) => {
        let id = data ? data.value : null;
        if (id) {
            let logs = CompleteReport.filter(t => t._id === id);
            if (logs.length > 0) {
                setLogData(logs[0].Logs);
            }
            else {
                setLogData([]);
            }
        }
        else {
            setLogData([]);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row" style={{ height: "78vh", overflow: "auto", padding: "0 10px 10px 10px" }}>

                    <div className="col-md-4 col-12">
                        <div className="dropdownMobile">
                            <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Partner"
                                options={PartnerData}
                                onChange={onPartnerChange}></Select>
                        </div>
                    </div>
                    <div className="col-md-6 col-10 align-center">
                        <h4>Tracking Report</h4>
                    </div>
                    <div className="col-md-2 col-2 align-center">
                        <div className={`${CurrentTheme}Color responsiveFont`} title="Download Chart" style={{ cursor: "pointer", fontSize: "25px", height: "50px" }}
                            onClick={DownloadImage}>
                            <FontAwesomeIcon icon={faDownload} />
                        </div>
                    </div>
                    <div id="chartTrack" className="col-md-12 col-12" style={{ marginBottom: "5px" }}>
                        <ResponsiveContainer width="100%" height={350}>
                            <BarChart barCategoryGap={0} width={730} height={250}
                                margin={{
                                    top: 35
                                }}
                                data={TrackReport}>
                                <XAxis stroke="black" interval={0}
                                    fontSize="12" height="75" textAnchor="end" angle={-90} dataKey="Name" />
                                <YAxis stroke="black" label={{ value: 'Tracking Count', angle: -90, position: 'insideLeft' }} />
                                <Tooltip />
                                <Bar radius={[20, 20, 0, 0]} dataKey="TrackCount" fill="#005582">
                                    {TrackReport.map((track, index) => (
                                        <Cell key={index} fill={getColor(track.TrackCount)} />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="col-md-12 col-12 legend-style">
                        <span style={{ backgroundColor: getColor(2) }}></span>{"<5"}
                        <span style={{ backgroundColor: getColor(10) }}></span>{"5-15"}
                        <span style={{ backgroundColor: getColor(20) }}></span>{"15-25"}
                        <span style={{ backgroundColor: getColor(30) }}></span>{"25-50"}
                        <span style={{ backgroundColor: getColor(60) }}></span>{">50"}
                    </div>
                    {LogData && LogData.length > 0 && (<div className="col-md-12 col-12" style={{ marginTop: "10px" }}>
                        <DataTable columns={columns} data={LogData}></DataTable>
                    </div>)}


                </div>
            </div>
        </div>
    );
};

export default TrackReport;